import "./Services.module.css";
import HeaderNavigazione from "@/reusable_sections/Header";
import SoluzioniIngegneristicheSuMisuraPerTe from "./sections/SoluzioniIngegneristicheSuMisuraPerTe";
import INostriServizi from "./sections/INostriServizi";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <HeaderNavigazione />
      <SoluzioniIngegneristicheSuMisuraPerTe />
      <INostriServizi />
      <Footer />
    </div>;
}